/**
 * How far (px) to pan the map when the sliders panel opens or closes: half of the
 * bottom panel's height, plus the top planning panel's height in route mode.
 */
export function getSlidersPanelMoveValue(viewportWidth: number, viewportHeight: number, routeMode: boolean): number {
  let moveValue = 0;
  const portrait = viewportHeight > viewportWidth;

  if (portrait) {
    const bottomHeight = (viewportHeight <= 550) ? 200 : 320;
    const topHeight = (viewportWidth <= 380) ? 260 : 308;
    moveValue += bottomHeight;
    if (routeMode) {
      moveValue += topHeight;
    }
  } else {
    const bottomHeight = (viewportHeight <= 550) ? 200 : 320;
    const topHeight = (viewportWidth <= 620) ? 53 : 64;
    moveValue += bottomHeight;
    if (routeMode) {
      moveValue += topHeight;
    }
  }
  return moveValue / 2;
}
